export default "__VITE_ASSET__lmapQ$VR__"